import * as React from "react";

import { ITheme } from "@fluentui/react";

import { AppThemeConsumer } from "@1js/acui-theme";
import { isReducedAnimations } from "@1js/window-util";

import {
  SelectedPivotIndicatorDirection,
  SelectedPivotIndicatorProps,
} from "./SelectedPivotIndicator.Props";
import {
  getSelectedPivotIndicatorClassNames,
  getSelectedPivotIndicatorStyles,
} from "./SelectedPivotIndicator.styles";

export class SelectedPivotIndicator extends React.PureComponent<
  SelectedPivotIndicatorProps,
  {}
> {
  public render() {
    const {
      position,
      offset = 0,
      length,
      thickness = 3,
      appColors,
      showAnimation,
      direction = SelectedPivotIndicatorDirection.Horizontal,
      styles,
    } = this.props;
    const animate = showAnimation && !isReducedAnimations();
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => {
          const classNames = getSelectedPivotIndicatorClassNames(
            getSelectedPivotIndicatorStyles(
              position,
              offset,
              length,
              thickness,
              animate,
              direction,
              theme,
              appColors,
              styles
            )
          );
          return <div className={classNames.root} />;
        }}
      </AppThemeConsumer>
    );
  }
}
